import './BetbookBetBox.less';

import React from 'react';

import BoxOptionsContext, { BETBOOK } from '@/nikeone/context/BoxOptionsContext';
import Tips from '@/nikeone/components/Tips';
import { ErrorBoundaryX } from '@/common/components/error/ErrorBoundary';
import { BetbookOddBetCount } from '@/betbook/views/BetbookOddBetCount';
import { sportEventUrlDescription } from 'nike-ui/src/common/sportEvents';

function BetbookBetBox({
    bet,
    betId,
    betSelectionCode,
    betSnapshot,
    initialOdds,
    match = betSnapshot,
    showSingleTip,
    showTitle
}) {
    const { sportEventId, matchId = sportEventId, participants } = match;
    const [home, away] = participants || [];
    const market = bet?.headerDetail || betSnapshot?.market;
    const matchBetCount = bet?.matchBetCount;
    const matchName = `${home}${away ? ` vs ${away}` : ''}`;
    const urlMeta = match && sportEventUrlDescription(match);
    return (
        <div className="bet-box" data-atid="betbook-nikeone-match">
            <BoxOptionsContext.Provider value={BETBOOK}>
                <div className="flex justify-between items-center">
                    {showTitle && <div className="bet-box-market">{market}</div>}
                    {matchBetCount && !showSingleTip ? (
                        <BetbookOddBetCount matchBetCount={matchBetCount} sportEventId={matchId} urlMeta={urlMeta} />
                    ) : null}
                </div>
                {showTitle && <div className="bet-box-event">({matchName})</div>}
                <ErrorBoundaryX description="Tips">
                    <Tips
                        boxStore="betbook"
                        betId={betId}
                        userTip={betSelectionCode}
                        betSnapshot={betSnapshot}
                        initialOdds={initialOdds}
                        showSingleTip={showSingleTip}
                        showEditorTips
                    />
                </ErrorBoundaryX>
            </BoxOptionsContext.Provider>
        </div>
    );
}

export default BetbookBetBox;
